import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "@/vendor/lenis.mjs";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/dealer/Nav";
import { Hero } from "@/components/dealer/Hero";
import { Marquee } from "@/components/dealer/Marquee";
import { Philosophy } from "@/components/dealer/Philosophy";
import { Representation } from "@/components/dealer/Representation";
import { Talent } from "@/components/dealer/Talent";
import { Approach } from "@/components/dealer/Approach";
import { BrandStatement } from "@/components/dealer/BrandStatement";
import { StrategicRole } from "@/components/dealer/StrategicRole";
import { FinalStatement } from "@/components/dealer/FinalStatement";
import { Contact } from "@/components/dealer/Contact";
import { Footer } from "@/components/dealer/Footer";
import Inbox from "@/components/dealer/Inbox";

const Home = ({ lang }) => {
  useEffect(() => {
    document.documentElement.lang = lang;
    window.scrollTo(0, 0);
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, [lang]);

  return (
    <>
      <Nav lang={lang} />
      <main>
        <Hero lang={lang} />
        <Marquee />
        <Philosophy lang={lang} />
        <Representation lang={lang} />
        <Talent lang={lang} />
        <Approach />
        <BrandStatement />
        <StrategicRole lang={lang} />
        <FinalStatement />
        <Contact lang={lang} />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="bg-dealer-black font-sans text-dealer-ivory">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home lang="en" />} />
          <Route path="/tr" element={<Home lang="tr" />} />
          <Route path="/it" element={<Home lang="it" />} />
          <Route path="/inbox" element={<Inbox />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        toastOptions={{
          style: {
            background: "#121417",
            border: "1px solid rgba(246,244,238,0.16)",
            color: "#F6F4EE",
          },
        }}
      />
    </div>
  );
}

export default App;
